import { FC } from 'react'
import DeactivateNotificationIntegration from '@/components/modals/DeactivateNotificationIntegration'

interface DeactivateVkNotificationCommunityProps {
  open?: boolean
  setOpen?: (open: boolean) => void
  integrationId?: number | null
  displayHandle?: string | null
}

const DeactivateVkNotificationCommunity: FC<DeactivateVkNotificationCommunityProps> = (props) => (
  <DeactivateNotificationIntegration provider="vkontakte" {...props} />
)

export default DeactivateVkNotificationCommunity
